import styled from 'styled-components'

const SectionHeading = styled.h2`
  font-size: ${ p => p.theme.typo.sizes.normal };
  font-weight: 500;
`

export default SectionHeading
